import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import NoPaymentImage from 'app/shared/images/nopayment@3x.png';

import './style.scss';

const propTypes = {
    notification: PropTypes.object,
};

const defaultProps = {
    notification: {},
};

const BillingEmptyBanner = ({ notification }) => (
    <div className="BillingEmptyBanner">
        <div className="BillingEmptyBanner-image-wrapper">
            <img className="BillingEmptyBanner-image" src={NoPaymentImage} alt="No Payments" />
        </div>
        <Text type="h2">{notification.title}</Text>
        {notification.text.map((text, i) => <Text key={i} type="body">{text}</Text>)}
    </div>
);

BillingEmptyBanner.propTypes = propTypes;
BillingEmptyBanner.defaultProps = defaultProps;

export default BillingEmptyBanner;
